
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'Modal',
    props: {
        title: String,
        modalId: String,
        text: String,
        buttonText: String,
        buttonClass: String,
    },
    setup() {
        return {
            
        }
    }
});

